// extracted by mini-css-extract-plugin
module.exports = {"ringsSpinner":"RingsSpinner_ringsSpinner__GTxSe","ringsSpinner__animated":"RingsSpinner_ringsSpinner__animated__fWI5r","jingle":"RingsSpinner_jingle__K_ViN"};